export default {"src":"/_next/static/media/titulo-de-eleitor.7a208085.svg","height":338,"width":512,"blurWidth":0,"blurHeight":0};